<template>
  <UiLink class="wrapper" name="index">
    <UiBaseIcon width="40px" height="40px" icon-name="cardprLogo" />
  </UiLink>
</template>

<script>
import UiLink from '@/components/UiLink.vue'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: { UiLink, UiBaseIcon },
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include createFlex(flexbox, nowrap, row, center, center, center);
  @include square($navbarWidth);
}
</style>
